import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useOkta } from 'utils/okta/use-okta';

import LoginLayout from 'containers/login/login-layout';
import OktaSignInWidget from 'containers/login/okta-widget/okta-sign-in-widget';
import ImplicitCallback from 'containers/login/okta-widget/implicit-callback';

import 'containers/login/okta-widget/okta-login.css';

const OktaSignInPage = () => (
  <LoginLayout withFooter={true}>
    <OktaSignInWidget />
  </LoginLayout>
);

const OktaLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const oktaAuth = useOkta();

  const isCallback = location.pathname.includes('/callback');

  useEffect(() => {
    window.localStorage.removeItem('fd_okta-impersonating-id');

    const checkAuth = async () => {
      try {
        const authState = await oktaAuth.isAuthenticated();

        if (authState && !isCallback) {
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error('Error checking authentication:', error);
      }
    };

    checkAuth();
  }, [location.pathname, isCallback, navigate, oktaAuth]);

  if (isCallback) {
    return <ImplicitCallback />;
  }

  return (
    <Routes>
      <Route path="*" element={<OktaSignInPage />} />
    </Routes>
  );
};

export default OktaLogin;
